export default "__VITE_ASSET__Bby_I$gP__"